import { render, staticRenderFns } from "./ProductRestockShop.vue?vue&type=template&id=a8bbd5f0&scoped=true"
import script from "./ProductRestockShop.vue?vue&type=script&lang=js"
export * from "./ProductRestockShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bbd5f0",
  null
  
)

export default component.exports